import script from "./CheckoutView.vue?vue&type=script&setup=true&lang=js"
export * from "./CheckoutView.vue?vue&type=script&setup=true&lang=js"

import "./CheckoutView.vue?vue&type=style&index=0&id=021d8ad4&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-021d8ad4"]])

export default __exports__